import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *模板列表
 * @param params
 * 
*/

export const templateList = params => Http.get(`${baseUrl}/sz/team/ly/template`, { params })

/**
 *我的路演列表
 * @param params
 * 
*/

export const myRoadshow = params => Http.get(`${baseUrl}/sz/team/ly/my`, { params })

/**
 *新增路演
 * @param params
 * 
*/

export const save = params => Http.post(`${baseUrl}/sz/team/ly/my`,  params )

/**
 *删除路演
 * @param ids
 * 
*/

export const del = ids => Http.delete(`${baseUrl}/sz/team/ly/my/${ids}` )

/**
 *团队成果
 * @param params
 * 
*/

export const result = params => Http.get(`${baseUrl}/sz/team/ly`, { params })
